import { Howl } from 'howler';

export const bgm = new Howl({
  src: ['/sounds/bgm.mp3'],
  loop: true,
  volume: 0.5,
  onplayerror: function() {
    bgm.once('unlock', function() {
      bgm.play();
    });
  }
});

export const click = new Howl({
  src: ['/sounds/click.mp3'],
  volume: 0.5
});

export const shot = new Howl({
  src: ['/sounds/shot.mp3'],
  volume: 0.25
});

export const reload = new Howl({
  src: ['/sounds/reload.mp3'],
  volume: 0.5
});

export const hit1 = new Howl({
  src: ['/sounds/hit1.mp3'],
  volume: 0.5
});

export const hit2 = new Howl({
  src: ['/sounds/hit2.mp3'],
  volume: 0.5
});

export const hit3 = new Howl({
  src: ['/sounds/hit3.mp3'],
  volume: 0.5
});

export const hit4 = new Howl({
  src: ['/sounds/hit4.mp3'],
  volume: 0.5
});

export const ability = new Howl({
  src: ['/sounds/ability.mp3'],
  volume: 0.5
});

export const death = new Howl({
  src: ['/sounds/death.mp3'],
  volume: 0.5
});

export const allSounds = [bgm, click, shot, reload, hit1, hit2, hit3, hit4, ability, death];
